import React from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {ChevronRightIcon} from '../../../components/icons'

/* Utils */
import {generateStyles} from '../../../components/optimizely/utils/utils'

const ShippingPickupOptions = ({deliveryOptionsData, cmsDeliverySectionBlock, openShippingPickupModal}) => {
    const styles = useMultiStyleConfig('InformationAccordion')
    const {formatMessage} = useIntl()

    if (!deliveryOptionsData || Object.keys(deliveryOptionsData).length === 0) {
        return null
    }

    return (
        <Button {...styles.navButton} onClick={openShippingPickupModal} data-testid="pdp-button-shipping-pickup-options">
            <Text
                as="h2"
                {...styles.navItemText}
                {...generateStyles(cmsDeliverySectionBlock?.DeliverySectionBlockTitleStyle, {
                    ...styles.navItemText
                })}
            >
                {cmsDeliverySectionBlock?.Title
                    ? cmsDeliverySectionBlock.Title
                    : formatMessage({
                        defaultMessage: 'Shipping & Pickup Options',
                        id: 'product_detail.accordion.button.shipping_and_pickup_options'
                    })}
                <ChevronRightIcon />
            </Text>
        </Button>
    )
}

ShippingPickupOptions.propTypes = {
    deliveryOptionsData: PropTypes.object,
    cmsDeliverySectionBlock: PropTypes.object,
    openShippingPickupModal: PropTypes.func
}

export default ShippingPickupOptions
